import {
	KEYCLOAK_CLIENT_ID,
	KEYCLOAK_REALM,
	KEYCLOAK_URL,
} from "@/constants/constants";
import { API, APIv2, APIv2_FormData, resetLogoutState } from "@/services/api";
import { type KeycloakAuth, setupKeycloakAuth } from "../services/keycloak";

// Internal singleton state
let _auth: KeycloakAuth | null = null;
let _ready: Promise<KeycloakAuth> | null = null;
let _resolve!: (a: KeycloakAuth) => void;

// Exposed “ready” promise anyone can await
export const authReady: Promise<KeycloakAuth> = new Promise<KeycloakAuth>(
	(res) => {
		_resolve = res;
	},
);

/** Call exactly once during app bootstrap */
export async function initAuth(): Promise<KeycloakAuth> {
	if (_auth) return _auth;
	if (!_ready) {
		_ready = setupKeycloakAuth({
			keycloakUrl: KEYCLOAK_URL,
			realm: KEYCLOAK_REALM,
			clientId: KEYCLOAK_CLIENT_ID,
			axiosInstances: [API, APIv2, APIv2_FormData],
		}).then((a) => {
			_auth = a;
			_resolve(a);
			resetLogoutState();
			return a;
		});
	}
	return _ready;
}

/** Async getter (safe anywhere, waits if not initialized yet) */
export async function getAuth(): Promise<KeycloakAuth> {
	if (_auth) return _auth;
	return authReady;
}

/** Synchronous convenience getters (undefined until initialized) */
export function getUser() {
	return _auth?.kc.tokenParsed;
}
export function getTokenSync() {
	return _auth?.getRawToken();
}
export async function ensureToken(minValidity = 10) {
	const a = await getAuth();
	return a.ensureToken(minValidity);
}
export async function logout() {
	const a = await getAuth();
	return a.doLogout();
}
